// src/pages/TermsConditions.jsx

import React, { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Spin, Result } from "antd";
import useRequest from "../hooks/useRequest";

const { Title, Text } = Typography;

const TermsConditions = () => {
  const { request } = useRequest();
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = () => {
    setLoading(true);
    setError(false);

    request({
      url: "/content?page_key=TERMS_OF_USE",
      method: "GET",
      auth: false, // Important if your hook auto-attaches token
      onSuccess: (res) => {
        // Handles different response shapes safely
        const data = res?.data?.data || res?.data;

        if (data) {
          setContent(data);
        } else {
          setError(true);
        }

        setLoading(false);
      },
      onError: () => {
        setError(true);
        setLoading(false);
      },
    });
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 120 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error || !content) {
    return (
      <Result
        status="404"
        title="Content Not Found"
        subTitle="Unable to load Terms & Conditions."
      />
    );
  }

  return (
    <div
      style={{
        padding: "60px 20px",
        background: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      <Row justify="center">
        <Col xs={24} sm={22} md={18} lg={16}>
          <Card
            bordered={false}
            style={{
              borderRadius: 16,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
            }}
          >
            <Title level={2} style={{ marginBottom: 10 }}>
              {content.page_name || "Terms & Conditions"}
            </Title>

            <Text type="secondary">
              Last updated:{" "}
              {content.updated_at
                ? new Date(content.updated_at).toLocaleDateString()
                : "-"}
            </Text>

            <div
              style={{
                marginTop: 30,
                lineHeight: 1.8,
                fontSize: 15,
              }}
              dangerouslySetInnerHTML={{
                __html: content.content,
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default TermsConditions;